import React from 'react';
import { MDText } from 'i18n-react';

import { Badge, ClockIcon, FireIcon, NoMoneyIcon, TargetIcon } from '@motorway/mw-highway-code';

import { BinCountdown } from './BinCountdown/BinCountdown';
import { SaleCountdown } from './SaleCountdown/SaleCountdown';
import statusBadgeTexts from './StatusBadge.texts';

const LocalT = new MDText(statusBadgeTexts);

export type BadgeVariant = 'saleCountdown' | 'saleOverProcessing' | 'underOffer' | 'sold' | 'binCountdown' | 'unsold';

export const StatusBadge: React.FC<{ variant: BadgeVariant }> = ({ variant }) => {
	switch (variant) {
		case 'saleCountdown':
			return <SaleCountdown />;
		case 'saleOverProcessing':
			return <Badge reverse icon={ClockIcon} text={LocalT.translate('saleOverProcessing')} variant="warning" />;
		case 'underOffer':
			return <Badge reverse icon={FireIcon} text={LocalT.translate('underOffer')} variant="primary" />;
		case 'sold':
			return <Badge reverse icon={TargetIcon} text={LocalT.translate('sold')} variant="error" />;
		case 'unsold':
			return <Badge reverse icon={NoMoneyIcon} text={LocalT.translate('unsold')} variant="default" />;
		case 'binCountdown':
			return <BinCountdown />;

		default:
			return null;
	}
};
